export interface IdArgs {
  id?: unknown;
  ids?: unknown;
}

export const coerceIds = (input: IdArgs): string[] => {
  const idsPart = Array.isArray(input?.ids)
    ? (input.ids.filter((x) => typeof x === "string") as string[])
    : [];
  const idPart = typeof input?.id === "string" ? [input.id] : [];
  const result = new Set<string>([...idsPart, ...idPart]);
  return Array.from(result);
};
